export enum ParentalControlSetupViews {
  'INITIAL',
  'DISABLE',
  'DISABLE_SUCCESS',
  'ENABLE',
  'ENABLE_SUCCESS',
}

type State = {
  view: ParentalControlSetupViews;
};

export const state: State = {
  view: ParentalControlSetupViews.INITIAL,
};
